module.exports = {
  menuName: '関連システム',
  subMenu: [
    {text: '顧客管理AGS', link: '/'},
    // {text: 'マイソクシステム', link: '/maisoku'},
    {text: '物件DB', link: 'https://admin-ph2.sumitas-web.com/saml2/authenticate/79985', isExternal: true},
  ],
}
